import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';
import type { AxiosResponse } from 'axios';

type ValidationResponse = {
	validation: {
		validity: boolean;
	};
};
class DiscountCodesService extends BaseService<
	DiscountCode,
	'discountCodeID',
	'discountCodes'
> {
	constructor() {
		super('discountCodeID', 'discountCode', 'discountCodes');
	}

	async validateDiscountCode(code: string) {
		const response: AxiosResponse<TavoittajaApiResponse<ValidationResponse>> =
			await axiosInstance.post(`/app/validation/discountCode`, {
				code: code,
			});

		return response.data;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new DiscountCodesService();
